export default __webpack_public_path__ + "static/media/masterassassin.0e543bcc.png";